<template>
</template>

<script>
import { logout } from '@/auth/auth';

export default {
  name: '',
  mounted() {
      logout();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Logout.vue?17061e94